export default "<span :class=\"className\">\n  <slot>{{ text }}</slot>\n</span>\n";